/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-25 22:12:01
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { URL } from 'src/constants/links';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import AffiliateProgramPresentImage from 'src/assets/images/common/affiliate-program-present.png';

import { getShop, nowTimestamp } from 'src/helpers';

type Props = {
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;
type State = {
  showBanner: boolean
};

class AffiliateProgramPresentModal extends Component<ComposedProps, State> {
  state = {
    showBanner: false
  };

  componentDidMount() {
    // Hide banner
    this.checkShowBanner();
  }

  render() {
    const { i18n } = this.props;
    const { showBanner } = this.state;

    return (
      <Modal
        open={showBanner}
        onClose={this.onDismiss}
        title={i18n.translate('AdminHTML.Common.AffiliateProgramPresentModal.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.learnMore'),
          onAction: () => this.openLink('AffiliateProgramDoc')
        }}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate('AdminHTML.Common.AffiliateProgramPresentModal.content', {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.Common.AffiliateProgramPresentModal.content_t1')}
                  </TextStyle>
                ),
                t2: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.Common.AffiliateProgramPresentModal.content_t2')}
                  </TextStyle>
                )
              })}
            </p>
            <img
              className="BC-Illustration-Image__Notification"
              src={AffiliateProgramPresentImage}
              alt="Affiliate program present"
            />
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  // Show banner status
  checkShowBanner = () => {
    const { tenantApp = {} } = this.props;
    const { affiliatePartner = '' } = tenantApp;

    if (affiliatePartner) {
      try {
        // Get showAt, closeAt and openLinkAt from localStorage
        let showAt = localStorage.getItem(`${getShop()}-affiliateProgramNotif-showAt`);
        showAt = showAt ? _.toNumber(showAt) * 1000 : 0;
        let closeAt = localStorage.getItem(`${getShop()}-affiliateProgramNotif-closeAt`);
        closeAt = closeAt ? _.toNumber(closeAt) * 1000 : 0;
        let openLinkAt = localStorage.getItem(`${getShop()}-affiliateProgramNotif-openLinkAt`);
        openLinkAt = openLinkAt ? _.toNumber(openLinkAt) * 1000 : 0;

        // Show once a day
        // Click on X  -> stops showing for the next 24h
        // Click on Learn More -> stops showing for the next 48h
        if (
          !(
            (showAt && moment().diff(moment(showAt), 'day') < 1) ||
            (closeAt && moment().diff(moment(closeAt), 'day') < 1) ||
            (openLinkAt && moment().diff(moment(openLinkAt), 'day') < 2)
          )
        ) {
          this.setState({ showBanner: true });
          // Set last time show up
          localStorage.setItem(`${getShop()}-affiliateProgramNotif-showAt`, nowTimestamp());
        }
      } catch (error) {
        this.setState({ showBanner: true });
      }
    }
  };

  // Handle hide banner
  onDismiss = () => {
    // Hide banner
    this.setState({ showBanner: false });

    // Set time
    try {
      localStorage.setItem(`${getShop()}-affiliateProgramNotif-closeAt`, nowTimestamp());
      localStorage.removeItem(`${getShop()}-affiliateProgramNotif-openLinkAt`);
    } catch (error) {}
  };

  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');

    // Hide banner
    this.setState({ showBanner: false });

    // Set time
    try {
      localStorage.setItem(`${getShop()}-affiliateProgramNotif-openLinkAt`, nowTimestamp());
      localStorage.removeItem(`${getShop()}-affiliateProgramNotif-closeAt`);
    } catch (error) {}
  };
}

export default withI18n()(AffiliateProgramPresentModal);
